import { SearchItem } from "@/types";

export interface Briefcase {
  // count: number;
  // nextPage: boolean;
  // previousPage: boolean;
  folders: Map<number, BriefcaseFolder>;
  foldersFlat: BriefcaseFolder[];
  itemIndex: Map<number, number[]>;
  defaultFolderId: number;
  currentFolderId: number;
  currentPage: number;
  pageSize: number;
  isLoading: boolean;
  lastUpdated: Date | null;
  itemBeingMoved: SearchItem | null; // The most recent item (un)starred.
}

export enum BriefcaseActions {
  ADD = "add",
  REMOVE = "remove",
  MOVE = "move",
}

export interface BriefcaseFolder {
  id: number;
  isDefault: boolean;
  name: string;
  items: BriefcaseItem[];
  // Needed to add divider to combobox on Briefcase page.
  divider?: boolean;
  dossierUrl: string;
}

export interface BriefcaseItem {
  subscriptionModules: number[];
  id: number;
  briefcaseId: number;
  positionSummary: string;
  preferredNameDisplay: string;
  title: string;
  politicalParty: string;
  quickSummary: string;
  headShot: string;
  isFormer: boolean;

  // TODO: so SearchItem can be assigned to BriefcaseItem
  addedToBriefcase: boolean;
}

export interface BriefcasePayload {
  items: BriefcaseItem[];
  folderId?: number;
}

export enum BriefcaseHardcodedIds {
  TOP_DIVIDER = -1,
  BREAKPOINT = 9007199254740980,
  BOTTOM_DIVIDER = 9007199254740988,
  NEW = 9007199254740989,
}

export function BriefcaseComparator(a: BriefcaseFolder, b: BriefcaseFolder): number {
  // Default folder goes to the top, top_divider is immediately after it,
  // bottom_divider and Add New link at the very end, custom folders stay in the middle and sorted alphabetically.

  if (a.isDefault) return -1;
  else if (b.isDefault) return 1;
  else if (a.id === BriefcaseHardcodedIds.TOP_DIVIDER) return -1;
  else if (b.id === BriefcaseHardcodedIds.TOP_DIVIDER) return 1;
  else if (a.id > BriefcaseHardcodedIds.BREAKPOINT || b.id > BriefcaseHardcodedIds.BREAKPOINT) return a.id - b.id;
  else return a.name.localeCompare(b.name, undefined, { sensitivity: "base" });
}
